import { render, staticRenderFns } from "./main-wrap.vue?vue&type=template&id=6be348e5"
import script from "./main-wrap.vue?vue&type=script&lang=js"
export * from "./main-wrap.vue?vue&type=script&lang=js"
import style0 from "./main-wrap.vue?vue&type=style&index=0&id=6be348e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports